@if ((elevation$ | async); as elevation) {
  <div class="container">
    <div>
      {{elevation.name}}
    </div>
    @if ((currentUser$ | async); as currentUser) {
      <div class="icons">
        @if (!elevation.show) {
          <mat-icon>visibility_off</mat-icon>
        }
        @if (elevation.isShared && currentUser.name == elevation.author) {
          <mat-icon>person</mat-icon>
        }
        @if (elevation.isShared) {
          <mat-icon>share</mat-icon>
        }
      </div>
    }
  </div>
}



